import './bootstrap';

const d = window.document;
window.trumbowygSettings = function () {
    return {
        btns: [
            //['viewHTML'],
            ['undo', 'redo'], // Only supported in Blink browsers
            ['formatting'],
            ['strong', 'em', 'del'],
            ['superscript', 'subscript', 'foreColor', 'backColor'],
            ['link'],
            //['insertImage'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
            ['unorderedList', 'orderedList'],
            ['horizontalRule'],
            ['removeformat'],
            ['fullscreen']
        ],
        autogrow: true,
        svgPath: '/assets/icons/trumbowyg-icons.svg'
    }
};

window.StoreDataTableSettings = function () {
    return true;
};

d.addEventListener('DOMContentLoaded', function (event) {

    // options
    const breakpoints = {
        sm: 540,
        md: 720,
        lg: 960,
        xl: 1140
    };

    var sidebar = document.getElementById('sidebarMenu');
    if (sidebar && d.body.clientWidth < breakpoints.lg) {
        sidebar.addEventListener('shown.bs.collapse', function () {
            document.querySelector('body').style.position = 'fixed';
        });
        sidebar.addEventListener('hidden.bs.collapse', function () {
            document.querySelector('body').style.position = 'relative';
        });
    }

    var iconNotifications = d.querySelector('.notification-bell');
    if (iconNotifications) {
        iconNotifications.addEventListener('shown.bs.dropdown', function () {
            iconNotifications.classList.remove('unread');
        });
    }

    //Tooltips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });

    if (d.querySelector('.flatpickr-date')) {
        window.flatpickers = [];
        [].slice.call(d.querySelectorAll('.flatpickr-date')).map(function (el) {
            let options = {
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "F j, Y",
                disableMobile: true
            }
            if (el.getAttribute('data-min-date')) {
                options.minDate = el.getAttribute('data-min-date');
            }
            if (el.getAttribute('data-max-date')) {
                options.maxDate = el.getAttribute('data-max-date');
            }
            if (el.getAttribute('data-disable-weekends')) {
                options.disable = [
                    function (date) {
                        return date.getDay() === 0 || date.getDay() === 6;
                    }
                ];
            }
            window.flatpickers[el.id] = window.flatpickr('.flatpickr-date', options);
        });
    }

    if (d.querySelector('.current-year')) {
        d.querySelector('.current-year').textContent = moment().year();
    }

    if (d.querySelector('select.form-select:not(.disable-select2)')) {
        [].slice.call(d.querySelectorAll('select.form-select:not(.disable-select2)')).map(function (el) {
            $('#' + el.id).select2({
                theme: 'bootstrap-5',
                minimumResultsForSearch: 10,
                placeholder: el.getAttribute('data-placeholder'),
                closeOnSelect: !el.getAttribute('multiple'),
                tags: !el.getAttribute('data-allow-custom-entries')
            });
        });
    }

    // Add spinner element after input type submit buttun on click action
    if (d.querySelector('input[type="submit"]:not(.no-spinner)')) {
        d.querySelector('input[type="submit"]').addEventListener('click', function (event) {
            var form = event.target.closest('form');
            var row = event.target.closest('div');
            form.insertAdjacentHTML('beforeend', '<div class="spinner-border d-none" role="status"><span class="visually-hidden">Loading...</span></div>');
            row.classList.add('d-none');
            form.querySelector('.spinner-border').classList.remove('d-none');
            setTimeout(() => {
                form.querySelector('.spinner-border').classList.add('d-none');
                row.classList.remove('d-none');
            }, 2000);
            return true;
        });
    }

    if (d.querySelectorAll('.trumbowyg-editor').length > 0) {
        [].slice.call(d.querySelectorAll('.trumbowyg-editor')).map((el) => {
            $(el).trumbowyg(window.trumbowygSettings());
        });
    }
});




